import React, { useState, useEffect } from 'react';
import './Advice.scss';
import lifestyleImg1 from '../../../assets/imgs/lifestyle-card-bg.jpg';
import lifestyleImg2 from '../../../assets/imgs/lifestyle-card-bg2.png';
import lifestyleImg3 from '../../../assets/imgs/lifestyle-card-bg3.png';
import ExpertVideo from '../../../assets/videos/advice-video.mp4';
// import Footer from '../../../Components/Footer/Footer';

const cards = [
  {
    tag: 'Lifestyle',
    title: 'How Sleep Impacts Your Health Every Day',
    desc: 'Small changes in sleep, stress and movement can support healthier sperm over the full 2–3 month cycle...',
    img: lifestyleImg1,
  },
  {
    tag: 'Lifestyle',
    title: 'Daily Habits Matter',
    desc: 'Small changes in sleep, stress and movement can support healthier sperm over the full 2–3 month cycle...',
    img: lifestyleImg2,
  },
  {
    tag: 'Lifestyle',
    title: 'Daily Habits Matter',
    desc: 'Small changes in sleep, stress and movement can support healthier sperm over the full 2–3 month cycle...',
    img: lifestyleImg3,
  },
  {
    tag: 'Lifestyle',
    title: 'Daily Habits Matter',
    desc: 'Small changes in sleep, stress and movement can support healthier sperm over the full 2–3 month cycle...',
    img: lifestyleImg2,
  },
];

const Advice = () => {
  const [activeLifestyle, setActiveLifestyle] = useState(0);
  const [activeNutrition, setActiveNutrition] = useState(0);
  const [activeExercise, setActiveExercise] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 767);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const visibleCards = isMobile ? 1 : 2;
  const cardWidth = isMobile ? 309 : 424; // card width + gap
  const maxIndex = cards.length - visibleCards;
  const totalDots = isMobile ? cards.length : maxIndex + 1;

  // Lifestyle section controls
  const prevLifestyle = () => activeLifestyle > 0 && setActiveLifestyle(activeLifestyle - 1);
  const nextLifestyle = () => activeLifestyle < maxIndex && setActiveLifestyle(activeLifestyle + 1);

  // Nutrition section controls
  const prevNutrition = () => activeNutrition > 0 && setActiveNutrition(activeNutrition - 1);
  const nextNutrition = () => activeNutrition < maxIndex && setActiveNutrition(activeNutrition + 1);

  // Exercise section controls
  const prevExercise = () => activeExercise > 0 && setActiveExercise(activeExercise - 1);
  const nextExercise = () => activeExercise < maxIndex && setActiveExercise(activeExercise + 1);

  return (
    <div className="advicepage">
      <div className="container">
        <div className="adviceSection">
          {/* Header */}
          <div className="advicepage__header">
            <div>
              <h3>Lifestyle & Daily Habits</h3>
              <p>Expand each metric to see detailed information and personalized recommendations</p>
            </div>

            {/* Desktop controls only */}
            {!isMobile && (
              <div className="advicepage__controls">
                <button onClick={prevLifestyle} disabled={activeLifestyle === 0}>
                  ‹
                </button>

                <div className="dots">
                  {Array.from({ length: totalDots }).map((_, i) => (
                    <span key={i} className={i === activeLifestyle ? 'active' : ''} />
                  ))}
                </div>

                <button onClick={nextLifestyle} disabled={activeLifestyle === maxIndex}>
                  ›
                </button>
              </div>
            )}
          </div>

          {/* Slider */}
          <div className="advicepage__slider">
            <div className="advicepage__track" style={{ transform: `translateX(-${activeLifestyle * cardWidth}px)` }}>
              {cards.map((card, i) => (
                <div className="habit-card" key={i} data-bs-toggle="modal" data-bs-target="#tipsModalLifestyle">
                  <div className="habit-card__image">
                    <img src={card.img} alt="" />
                  </div>

                  <div className="habit-card__content d-flex flex-column justify-content-between">
                    <div className="">
                      <span className="tag">{card.tag}</span>
                      <h4>{card.title}</h4>
                      <p>{card.desc}</p>
                    </div>
                    <a href="#">Learn more</a>
                  </div>
                </div>
              ))}
            </div>
            {/* modal here */}
            <div className="modal fade tipsmodal" id="tipsModalLifestyle" tabIndex="-1" aria-labelledby="tipsModalLifestyleLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="graph"></div>
                  </div>
                  <div className="modal-body">
                    <div className="">
                      <span className="tag">LIFESTYLE</span>
                      <h3 className="modal-title" id="tipsModalLifestyleLabel">
                        How Sleep Impacts Your Health Every Day
                      </h3>
                    </div>
                    <p>
                      Sleep is one of the strongest factors that influence semen quality. Your body repairs, regulates hormones and builds new cells
                      during the night. When sleep is irregular, these processes become less stable, which can affect your fertility baseline over the
                      full two to three month cycle.
                    </p>
                    <p>Below are simple habits that help you get more solid rest.</p>
                    <div>
                      <p className="blue-text">1. Keep the same sleep and wake time</p>
                      <p>
                        Your body likes rhythm. Going to bed and waking up at roughly the same time helps regulate testosterone and overall hormone
                        balance. Try to keep your schedule steady, even on weekends.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">2. Limit screens before bed</p>
                      <p>
                        Blue light makes it harder for your brain to slow down. Choose low light, put your phone away at least 30 to 45 minutes before
                        sleep and switch to calmer activities like reading or stretching.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">3. Create a darker and cooler room</p>
                      <p>
                        A cool, dark space helps your body fall asleep faster. Use blackout curtains if possible, remove bright LEDs in the bedroom
                        and keep the temperature slightly lower than during the day.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">4. Cut caffeine later in the day</p>
                      <p>
                        Caffeine can stay active for hours. If you often struggle to fall asleep, try avoiding coffee and energy drinks after
                        mid-afternoon. This small shift can make a big difference in your sleep rhythm.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">5. Build a wind-down routine</p>
                      <p>
                        Your brain needs time to slow down. A short routine like a warm shower, breathing exercises or gentle stretches tells your
                        body it’s time to switch off. Keep it simple and repeat it daily so it becomes natural.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile dots */}
          {isMobile && (
            <div className="advicepage__mobile-dots">
              {cards.map((_, i) => (
                <span key={i} className={i === activeLifestyle ? 'active' : ''} onClick={() => setActiveLifestyle(i)} />
              ))}
            </div>
          )}
        </div>

        <div className="expert-card">
          <div className="expert-card__media">
            <video className="expert-card__video" autoPlay loop muted playsInline>
              <source src={ExpertVideo} type="video/mp4" />
            </video>
          </div>

          <div className="expert-card__content">
            <div className="expert-card-top">
              <h2 className="expert-card__title">Speak With an Expert</h2>

              <p className="expert-card__description">
                Get personal guidance on your results and next steps from a fertility specialist. They&#39;ll help you understand what each metric
                means and what you can do to improve.
              </p>
            </div>
            <div className="expert-card-bottom">
              <div className="expert-card__meta">
                <span className="expert-card__icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="9" cy="9" r="8.5" stroke="#000D31" />
                    <path d="M9 3.27295V9.8184H13.9091" stroke="#000D31" />
                  </svg>
                </span>
                <span className="expert-card__time">60 minutes call</span>
              </div>

              <button className="btn btn-outline w-fit">Plan a call</button>

              <p className="expert-card__note">For information only. Not a substitute for medical advice.</p>
            </div>
          </div>
        </div>

        <div className="adviceSection">
          {/* Header */}
          <div className="advicepage__header">
            <div>
              <h3>Nutrition & Diet</h3>
              <p>Expand each metric to see detailed information and personalized recommendations</p>
            </div>

            {/* Desktop controls only */}
            {!isMobile && (
              <div className="advicepage__controls">
                <button onClick={prevNutrition} disabled={activeNutrition === 0}>
                  ‹
                </button>

                <div className="dots">
                  {Array.from({ length: totalDots }).map((_, i) => (
                    <span key={i} className={i === activeNutrition ? 'active' : ''} />
                  ))}
                </div>

                <button onClick={nextNutrition} disabled={activeNutrition === maxIndex}>
                  ›
                </button>
              </div>
            )}
          </div>

          {/* Slider */}
          <div className="advicepage__slider">
            <div className="advicepage__track" style={{ transform: `translateX(-${activeNutrition * cardWidth}px)` }}>
              {cards.map((card, i) => (
                <div className="habit-card" key={i} data-bs-toggle="modal" data-bs-target="#tipsModalNutrition">
                  <div className="habit-card__image">
                    <img src={card.img} alt="" />
                  </div>

                  <div className="habit-card__content d-flex flex-column justify-content-between">
                    <div className="">
                      <span className="tag">{card.tag}</span>
                      <h4>{card.title}</h4>
                      <p>{card.desc}</p>
                    </div>
                    <a href="#">Learn more</a>
                  </div>
                </div>
              ))}
            </div>
            {/* modal here */}
            <div className="modal fade tipsmodal" id="tipsModalNutrition" tabIndex="-1" aria-labelledby="tipsModalNutritionLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="graph"></div>
                  </div>
                  <div className="modal-body">
                    <div className="">
                      <span className="tag">NUTRITION</span>
                      <h3 className="modal-title" id="tipsModalNutritionLabel">
                        How Sleep Impacts Your Health Every Day
                      </h3>
                    </div>
                    <p>
                      Sleep is one of the strongest factors that influence semen quality. Your body repairs, regulates hormones and builds new cells
                      during the night. When sleep is irregular, these processes become less stable, which can affect your fertility baseline over the
                      full two to three month cycle.
                    </p>
                    <p>Below are simple habits that help you get more solid rest.</p>
                    <div>
                      <p className="blue-text">1. Keep the same sleep and wake time</p>
                      <p>
                        Your body likes rhythm. Going to bed and waking up at roughly the same time helps regulate testosterone and overall hormone
                        balance. Try to keep your schedule steady, even on weekends.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">2. Limit screens before bed</p>
                      <p>
                        Blue light makes it harder for your brain to slow down. Choose low light, put your phone away at least 30 to 45 minutes before
                        sleep and switch to calmer activities like reading or stretching.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">3. Create a darker and cooler room</p>
                      <p>
                        A cool, dark space helps your body fall asleep faster. Use blackout curtains if possible, remove bright LEDs in the bedroom
                        and keep the temperature slightly lower than during the day.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">4. Cut caffeine later in the day</p>
                      <p>
                        Caffeine can stay active for hours. If you often struggle to fall asleep, try avoiding coffee and energy drinks after
                        mid-afternoon. This small shift can make a big difference in your sleep rhythm.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">5. Build a wind-down routine</p>
                      <p>
                        Your brain needs time to slow down. A short routine like a warm shower, breathing exercises or gentle stretches tells your
                        body it&#39;s time to switch off. Keep it simple and repeat it daily so it becomes natural.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile dots */}
          {isMobile && (
            <div className="advicepage__mobile-dots">
              {cards.map((_, i) => (
                <span key={i} className={i === activeNutrition ? 'active' : ''} onClick={() => setActiveNutrition(i)} />
              ))}
            </div>
          )}
        </div>

        <div className="adviceSection">
          {/* Header */}
          <div className="advicepage__header">
            <div>
              <h3>Excersice & Fitness</h3>
              <p>Expand each metric to see detailed information and personalized recommendations</p>
            </div>

            {/* Desktop controls only */}
            {!isMobile && (
              <div className="advicepage__controls">
                <button onClick={prevExercise} disabled={activeExercise === 0}>
                  ‹
                </button>

                <div className="dots">
                  {Array.from({ length: totalDots }).map((_, i) => (
                    <span key={i} className={i === activeExercise ? 'active' : ''} />
                  ))}
                </div>

                <button onClick={nextExercise} disabled={activeExercise === maxIndex}>
                  ›
                </button>
              </div>
            )}
          </div>

          {/* Slider */}
          <div className="advicepage__slider">
            <div className="advicepage__track" style={{ transform: `translateX(-${activeExercise * cardWidth}px)` }}>
              {cards.map((card, i) => (
                <div className="habit-card" key={i} data-bs-toggle="modal" data-bs-target="#tipsModalExercise">
                  <div className="habit-card__image">
                    <img src={card.img} alt="" />
                  </div>

                  <div className="habit-card__content d-flex flex-column justify-content-between">
                    <div className="">
                      <span className="tag">{card.tag}</span>
                      <h4>{card.title}</h4>
                      <p>{card.desc}</p>
                    </div>
                    <a href="#">Learn more</a>
                  </div>
                </div>
              ))}
            </div>
            {/* modal here */}
            <div className="modal fade tipsmodal" id="tipsModalExercise" tabIndex="-1" aria-labelledby="tipsModalExerciseLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="graph"></div>
                  </div>
                  <div className="modal-body">
                    <div className="">
                      <span className="tag">EXERCISE</span>
                      <h3 className="modal-title" id="tipsModalExerciseLabel">
                        How Sleep Impacts Your Health Every Day
                      </h3>
                    </div>
                    <p>
                      Sleep is one of the strongest factors that influence semen quality. Your body repairs, regulates hormones and builds new cells
                      during the night. When sleep is irregular, these processes become less stable, which can affect your fertility baseline over the
                      full two to three month cycle.
                    </p>
                    <p>Below are simple habits that help you get more solid rest.</p>
                    <div>
                      <p className="blue-text">1. Keep the same sleep and wake time</p>
                      <p>
                        Your body likes rhythm. Going to bed and waking up at roughly the same time helps regulate testosterone and overall hormone
                        balance. Try to keep your schedule steady, even on weekends.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">2. Limit screens before bed</p>
                      <p>
                        Blue light makes it harder for your brain to slow down. Choose low light, put your phone away at least 30 to 45 minutes before
                        sleep and switch to calmer activities like reading or stretching.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">3. Create a darker and cooler room</p>
                      <p>
                        A cool, dark space helps your body fall asleep faster. Use blackout curtains if possible, remove bright LEDs in the bedroom
                        and keep the temperature slightly lower than during the day.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">4. Cut caffeine later in the day</p>
                      <p>
                        Caffeine can stay active for hours. If you often struggle to fall asleep, try avoiding coffee and energy drinks after
                        mid-afternoon. This small shift can make a big difference in your sleep rhythm.
                      </p>
                    </div>
                    <div>
                      <p className="blue-text">5. Build a wind-down routine</p>
                      <p>
                        Your brain needs time to slow down. A short routine like a warm shower, breathing exercises or gentle stretches tells your
                        body it&#39;s time to switch off. Keep it simple and repeat it daily so it becomes natural.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile dots */}
          {isMobile && (
            <div className="advicepage__mobile-dots">
              {cards.map((_, i) => (
                <span key={i} className={i === activeExercise ? 'active' : ''} onClick={() => setActiveExercise(i)} />
              ))}
            </div>
          )}
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Advice;
